import { gql } from '@apollo/client'

export const DELETE_ONE_BOOKMARK = gql`
  mutation deleteOneBookmark($bookmarkId: String!) {
    deleteOneBookmark(bookmarkId: $bookmarkId)
  }
`
